<script>
import DataProvider from './DataProvider.vue';
import SectionRelationRepository from '../../js/repository/SectionRelationRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: SectionRelationRepository.findAll,
                params: [this.kindergartenId],
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
